module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iYzViZTRkZjMtMmIzZS00ZDNlLWFjNWYtZmVkYWE2ODJiOGM2IiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDgwIDgwIj4KICA8dGl0bGU+QXJ0Ym9hcmQgMTwvdGl0bGU+CiAgPGc+CiAgICA8ZyBzdHlsZT0ib3BhY2l0eTogMC4zOTk5OTM5ODU4OTEzNDIxNiI+CiAgICAgIDxwYXRoIGQ9Ik00MCw4MEE0MCw0MCwwLDEsMCwwLDQwLDQwLDQwLDAsMCwwLDQwLDgwIiBzdHlsZT0iZmlsbDogI2ZmZiIvPgogICAgPC9nPgogICAgPHBvbHlnb24gcG9pbnRzPSIzNC4wOSAyNi41MiAzNC4wOSA1My40OCA1MC4wNSA0MCAzNC4wOSAyNi41MiIgc3R5bGU9ImZpbGw6ICNmZmYiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.svg
// module id = Bc8N
// module chunks = 1